export const initOTPless = (callback) => {
    const otplessInit = Reflect.get(window, "otplessInit");

    const loadScript = () => {
        const isScriptLoaded = document.getElementById("otpless-sdk");
        if (isScriptLoaded) return;

        const script = document.createElement('script')
        script.id = 'otpless-sdk'
        script.type = 'text/javascript'
        script.src = 'https://otpless.com/v2/auth.js'
        script.setAttribute("data-appid", "AM2KVUUTD4KQE5J03U1H")

        document.body.appendChild(script);
        // // Set the OTPless-specific cookie with SameSite=None and Secure attributes
        // document.cookie = "cookieName=cookieValue; SameSite=None; Secure";
    };

    otplessInit ? otplessInit() : loadScript();

    Reflect.set(window, "otpless", callback);
};
